import Vue from "vue";
import Router from "vue-router";
// session components
import AppLanding from "@/router/views/account/AppLanding.vue";
import TenantGateway from "@/router/views/account/TenantGateway.vue";
import DashBoard from "@/router/views/dashboards/default.vue";
import UserRegistration from "@/router/views/account/UserRegistration.vue";
import UserRegistrationSuccess from "@/router/views/account/UserRegistrationSuccess.vue";
import Listing from "./views/superLists/Listing.vue";
import Profile from "./views/account/UserProfile.vue";
import SessionTimeOut from "./views/account/SessionTimeOut.vue";
import ForgotPassword from "./views/account/ForgotPassword.vue";
import ImageCropper from "@/router/views/shared/ImageCropper.vue";
import NotFound from "@/router/views/shared/NotFound.vue";
import DndShipper from "@/router/views/shared/DnDShipper.vue";
import ClockworkAnalytics from "@/router/views/analytics/ClockworkAnalytics.vue";
import UserLogins from "@/router/views/analytics/UserLogins.vue";
import ProjectAnalytics from "@/router/views/analytics/ProjectAnalytics.vue";
import DragAndDrop from "@/router/views/shared/DragAndDrop.vue";
import UIElements from "@/router/views/shared/UIElements.vue";
// TEAMS
import Teams from "@/router/views/teams/TeamList.vue";
import AddTeam from "@/router/views/teams/AddTeam.vue";
import EditTeam from "@/router/views/teams/EditTeam.vue";
import ViewTeam from "@/router/views/teams/ViewTeam.vue";
import Tools from "./views/Tools/Tools.vue";
import ToolAdd from "./views/Tools/AddTool.vue";
import UpdateTool from "./views/Tools/UpdateTool.vue";
import ViewTool from "./views/Tools/ViewTool.vue";
import Services from "./views/service/Services.vue";
import ServiceAdd from "./views/service/ServiceAdd.vue";
import ServiceUpdate from "./views/service/ServiceUpdate.vue";
import ViewService from "./views/service/ServiceView.vue";
import AddProducts from "@/router/views/products/AddProducts.vue";
import EditProducts from "@/router/views/products/EditProducts.vue";
import ViewProducts from "@/router/views/products/ViewProducts.vue";
import Products from "@/router/views/products/Products.vue";
import AddAsset from "@/router/views/asset/AddAsset.vue";
import EditAsset from "@/router/views/asset/EditAsset.vue";
import ViewAsset from "@/router/views/asset/ViewAsset.vue";
import Engagement from "@/router/views/engagements/Engagement.vue";
import EngagementList from "@/router/views/engagements/EngagementList.vue";
import EngagementTemplate from "@/router/views/engagements/EngagementTemplates.vue";
Vue.use(Router);
export default new Router({
    routes: [
        {
            name: "default",
            path: "/",
            component: AppLanding,
            meta: {
                publicPage: true,
                tenantAgnostic: true,
            },
        },
        {
            name: "SessionTimeOut",
            path: "/sessiontimeout",
            component: SessionTimeOut,
            meta: {
                publicPage: true,
                tenantAgnostic: true,
            },
        },
        {
            name: "ForgotPassword",
            path: "/forgotpassword",
            component: ForgotPassword,
            meta: {
                publicPage: true,
                tenantAgnostic: true,
            },
        },
        {
            name: "UserRegistration",
            path: "/user-registration",
            component: UserRegistration,
            meta: {
                publicPage: true,
                tenantAgnostic: true,
            },
        },
        {
            name: "UserRegistrationSuccess",
            path: "/user-registration-success",
            component: UserRegistrationSuccess,
            meta: {
                publicPage: true,
                tenantAgnostic: true,
            },
        },
        {
            name: "TenantGateway",
            path: "/tenant-gateway",
            component: TenantGateway,
            meta: {
                tenantAgnostic: true,
            },
        },
        {
            name: "DashBoard",
            path: "/dashboard",
            component: DashBoard,
            meta: {},
        },
        {
            name: "ClockWork",
            path: "/ClockWork",
            component: () => import(/* webpackChunkName: "ClockWork" */ "@/router/views/clockWork/ClockWork.vue"),
            meta: {},
        },
        {
            name: "Listing",
            path: "/listing",
            component: Listing,
            meta: {},
        },
        // {
        //     name: "Profile",
        //     path: "/profile",
        //     component: Profile,
        //     meta: {},
        // },
        // {
        //     component: ImageCropper,
        //     path: "/image-cropper",
        //     name: "ImageCropper",
        //     meta: {},
        // },
        {
            name: "Profile",
            path: "/profile",
            component: Profile,
            meta: {},
        },
        {
            component: ImageCropper,
            path: "/image-cropper",
            name: "ImageCropper",
            meta: {},
        },
        {
            name: "NotFound",
            path: "*",
            component: NotFound,
            meta: {},
        },
        {
            name: "Projects",
            path: "/projects",
            component: () => import(/* webpackChunkName: "Projects"*/ "@/router/views/pmo/Projects.vue"),
            meta: {},
        },
        {
            name: "CreateNewProject",
            path: "/projects/create",
            component: () => import(/* webpackChunkName: "Projects"*/ "@/router/views/pmo/CreateNewProject.vue"),
            meta: {},
        },
        {
            name: "ProjectOverview",
            path: "/projects/projects-overview/:projectId",
            component: () => import(/* webpackChunkName: "Projects"*/ "@/router/views/pmo/ProjectOverview.vue"),
            meta: {},
        },
        {
            name: "Tags",
            path: "/tags",
            component: () => import(/* webpackChunkName: "Tags" */ "@/router/views/pmo/Tags.vue"),
            meta: {},
        },
        {
            name: "Project Tags",
            path: "/projectTags",
            component: () => import(/* webpackChunkName: "Tags" */ "@/router/views/pmo/ProjectTags.vue"),
            meta: {},
        },
        {
            component: DndShipper,
            path: "/dnd-shipper",
            name: "DndShipper",
            meta: {},
        },
        {
            component: ClockworkAnalytics,
            path: "/clockwork-analytics",
            name: "ClockworkAnalytics",
            meta: {},
        },
        {
            component: UserLogins,
            path: "/user-Logins",
            name: "UserLogins",
            meta: {},
        },
        {
            name: "PrayTube",
            path: "/pray-tube",
            component: () => import(/* webpackChunkName: "PrayTube"*/ "@/router/views/prayTube/PrayTube.vue"),
            meta: {},
        },
        // {
        //     component: DragAndDrop,
        //     path: "/draganddrop",
        //     name: "DragAndDrop",
        //     meta: {},
        // },
        // {
        //     component: UIElements,
        //     path: "/ui-elements",
        //     name: "UI Elements",
        //     meta: {},
        // },
        /* Employees */
        {
            name: "Employees",
            path: "/employees",
            component: () => import(/* webpackChunkName: "Employees" */ "@/router/views/employees/EmployeesList.vue"),
            meta: {},
        },
        {
            name: "AddEmployee",
            path: "/employees/add",
            component: () => import(/* webpackChunkName: "Employees" */ "@/router/views/employees/AddEmployee.vue"),
            meta: {},
        },
        {
            name: "EditEmployee",
            path: "/employees/:employeeId/edit",
            component: () => import(/* webpackChunkName: "Employees" */ "@/router/views/employees/EditEmployee.vue"),
            meta: {},
        },
        {
            name: "ViewEmployee",
            path: "/employees/:employeeId/view",
            component: () => import(/* webpackChunkName: "Employees" */ "@/router/views/employees/ViewEmployee.vue"),
            meta: {},
        },
        /* Employee Users*/
        {
            name: "Employee Users",
            path: "/employeeUsers",
            component: () => import(/* webpackChunkName: "Projects"*/ "@/router/views/employeeusers/EmployeeUsers.vue"),
            meta: {},
        },
        {
            name: "ListManager",
            path: "/listManager",
            component: () => import(/* webpackChunkName: "Projects"*/ "@/router/views/listManager/ListManager.vue"),
            meta: {},
        },
        // {
        //     name: "NotFound",
        //     path: "*",
        //     component: NotFound,
        //     meta: {},
        // },
        {
            name: "Teams",
            path: "/teams",
            component: Teams,
            meta: {},
        },
        {
            name: "AddTeam",
            path: "/teams/addTeam",
            component: AddTeam,
            meta: {},
        },
        {
            name: "EditTeam",
            path: "/teams/:teamId/editteam",
            component: EditTeam,
            meta: {},
        },
        {
            name: "ViewTeam",
            path: "/teams/:teamId",
            component: ViewTeam,
            meta: {},
        },
        // {
        //     component: DndShipper,
        //     path: "/dnd-shipper",
        //     name: "DndShipper",
        //     meta: {},
        // },
        // {
        //     component: ClockworkAnalytics,
        //     path: "/clockwork-analytics",
        //     name: "ClockworkAnalytics",
        //     meta: {},
        // },
        {
            component: ProjectAnalytics,
            path: "/project-analytics",
            name: "ProjectAnalytics",
            meta: {},
        },
        // {
        //     name: "PrayTube",
        //     path: "/pray-tube",
        //     component: () => import(/* webpackChunkName: "PrayTube"*/ "@/router/views/prayTube/PrayTube.vue"),
        //     meta: {},
        // },
        {
            component: DragAndDrop,
            path: "/draganddrop",
            name: "DragAndDrop",
            meta: {},
        },
        {
            name: "Multiselect",
            path: "/multiselect",
            component: () => import(/* webpackChunkName: "PrayTube"*/ "@/router/views/shared/Multiselect.vue"),
            meta: {},
        },
        // {
        //     name: "Bulkselection",
        //     path: "/bulkselection",
        //     component: () => import(/* webpackChunkName: "PrayTube"*/ "@/router/views/shared/Bulkselection.vue"),
        //     meta: {},
        // },
        {
            name: "VueGridLayout",
            path: "/vueGridLayout",
            component: () => import(/* webpackChunkName: "VueGridLayout"*/ "@/router/views/shared/VueGridLayout.vue"),
            meta: {},
        },
        {
            name: "TreeView",
            path: "/treeView",
            component: () => import(/* webpackChunkName: "PrayTube"*/ "@/router/views/shared/TreeView.vue"),
            meta: {},
        },
        {
            component: UIElements,
            path: "/ui-elements",
            name: "UI Elements",
            meta: {},
        },
        {
            name: "Tools",
            path: "/tools",
            component: Tools,
            meta: {},
        },
        {
            name: "UpdateTool",
            path: "/tools/:id/UpdateTool",
            component: UpdateTool,
            meta: {},
        },
        {
            name: "ToolAdd",
            path: "/tools/ToolAdd",
            component: ToolAdd,
            meta: {},
        },
        {
            name: "ViewTool",
            path: "/tools/ViewTool",
            component: ViewTool,
            meta: {},
        },
        {
            name: "Services",
            path: "/services",
            component: Services,
            meta: {},
        },
        {
            name: "ServiceAdd",
            path: "/services/service/AddService",
            component: ServiceAdd,
            meta: {},
        },
        {
            name: "ServiceUpdate",
            path: "/services/service/:id/UpdateService",
            component: ServiceUpdate,
            meta: {},
        },
        {
            name: "ViewService",
            path: "/services/service/:id/ViewService",
            component: ViewService,
            meta: {},
        },
        {
            name: "Products",
            path: "/products",
            component: Products,
            meta: {},
        },
        {
            name: "AddProducts",
            path: "/products/addProducts",
            component: AddProducts,
            meta: {},
        },
        {
            name: "EditProducts",
            path: "/products/editProducts/:productId",
            component: EditProducts,
            meta: {},
        },
        {
            name: "ViewProducts",
            path: "/products/ViewProducts/:viewProductId",
            component: ViewProducts,
            meta: {},
        },
        {
            name: "assetMaster",
            path: "/assetMaster",
            component: () => import(/* webpackChunkName: "AssetMaster"*/ "@/router/views/asset/AssetMaster.vue"),
            meta: {},
        },
        {
            name: "assetManager",
            path: "/assetManager",
            component: () => import(/* webpackChunkName: "assetManager"*/ "@/router/views/asset/AssetManager.vue"),
            meta: {},
        },
        {
            name: "assetAssignment",
            path: "/assetAssignment",
            component: () => import(/* webpackChunkName: "AssetMaster"*/ "@/router/views/asset/AssetAssignment.vue"),
            meta: {},
        },
        {
            name: "AddAsset",
            path: "/assetManager/addAsset",
            component: AddAsset,
            meta: {},
        },
        {
            name: "EditAsset",
            path: "/assetManager/editAsset/:assetId",
            component: EditAsset,
            meta: {},
        },
        {
            name: "ViewAsset",
            path: "/assetManager/viewAsset",
            component: ViewAsset,
            meta: {},
        },
        {
            name: "assetDepreciation",
            path: "/assetDepreciation",
            component: () => import(/* webpackChunkName: "assetDepreciation"*/ "@/router/views/asset/AssetDepreciation.vue"),
            meta: {},
        },
        //Page Manager
        {
            name: "PageManager",
            path: "/pages",
            props: true,
            component: () => import(/* webpackChunkName: "PageManager" */ "@/router/views/page-manager/Pages.vue"),
            meta: {},
        },
        //Menu Manager
        {
            name: "MenuManager",
            path: "/menu",
            props: true,
            component: () => import(/* webpackChunkName: "MenuManager" */ "@/router/views/menu-manager/menu.vue"),
            meta: {},
        },
        //Script Manager
        {
            name: "ScriptManager",
            path: "/script",
            props: true,
            component: () => import(/* webpackChunkName: "ScriptManager" */ "@/router/views/script-manager/ScriptManager.vue"),
            meta: {},
        },
        //Role Manager
        {
            name: "RoleManager",
            path: "/role",
            props: true,
            component: () => import(/* webpackChunkName: "Role" */ "@/router/views/roles/RolesManager.vue"),
            meta: {},
        },
        {
            name: "USZipCode",
            path: "/usZipCode",
            component: () => import(/* webpackChunkName: "Projects"*/ "@/router/views/usZipCode/USZipCode.vue"),
            meta: {},
        },
        {
            name: "Notification",
            path: "/notification",
            props: true,
            component: () => import(/* webpackChunkName: "Role" */ "@/router/views/notification/Notification.vue"),
            meta: {},
        },
        {
            name: "WorkView",
            path: "/workView",
            component: () => import(/* webpackChunkName: "Projects"*/ "@/router/views/workView/Workview.vue"),
            meta: {},
        },
        /* Reports */
        {
            name: "AssetStatusReport",
            path: "/assetStatusReport",
            component: () => import(/* webpackChunkName: "Status" */ "@/router/views/report/AssetCurrentReport.vue"),
            meta: {},
        },
        {
            name: "TimeReport",
            path: "/timeReport",
            component: () => import(/* webpackChunkName: "Vendors" */ "@/router/views/report/TimeReport.vue"),
            meta: {},
        },
        {
            name: "TagReport",
            path: "/tagReport",
            component: () => import(/* webpackChunkName: "Tags" */ "@/router/views/report/TagReport.vue"),
            meta: {},
        },
        {
            name: "ProjectReport",
            path: "/projectReport",
            component: () => import(/* webpackChunkName: "Vendors" */ "@/router/views/report/ProjectReport.vue"),
            meta: {},
        },
        {
            name: "AssetPurchase",
            path: "/assetPurchaseReport",
            component: () => import(/* webpackChunkName: "Vendors" */ "@/router/views/report/AssetPurchaseReport.vue"),
            meta: {},
        },
        {
            name: "AssetSummary",
            path: "/assetSummaryReport",
            component: () => import(/* webpackChunkName: "Vendors" */ "@/router/views/report/AssetSummaryReport.vue"),
            meta: {},
        },
        {
            name: "AssetCullOutReport",
            path: "/assetCullOutReport",
            component: () => import(/* webpackChunkName: "Vendors" */ "@/router/views/report/AssetCullOutReport.vue"),
            meta: {},
        },
        {
            name: "AssetScrappedDisposedReport",
            path: "/assetDisposalReport",
            component: () => import(/* webpackChunkName: "Vendors" */ "@/router/views/report/AssetScrappedDisposedReport.vue"),
            meta: {},
        },
        /* Vendors */
        {
            name: "Vendors",
            path: "/vendors",
            component: () => import(/* webpackChunkName: "Vendors" */ "@/router/views/vendors/VendorsList.vue"),
            meta: {},
        },
        // Cilent Engagements
        {
            name: "Engagement",
            path: "/engagementList/engagement",
            component: Engagement,
            meta: {},
        },
        {
            name: "EngagementList",
            path: "/engagementList",
            component: EngagementList,
            meta: {},
        },
        {
            name: "EngagementTemplate",
            path: "/engagementTemplate",
            component: EngagementTemplate,
            meta: {},
        },
        /* Designation */
        {
            name: "Designation",
            path: "/designations",
            component: () => import(/* webpackChunkName: "Designation" */ "@/router/views/designation/DesignationList.vue"),
            meta: {},
        },
        // PA Review
        {
            name: "ReviewListing",
            path: "/performance/reviews",
            component: () => import(/* webpackChunkName: "performance" */ "@/router/views/performance/reviews/ReviewListing.vue"),
            meta: {},
        },
        {
            name: "ClientInteraction",
            path: "/performance/reviews/assign/:cycleId/:stepId",
            component: () => import(/* webpackChunkName: "performance" */ "@/router/views/performance/reviews/ClientInteraction.vue"),
            meta: {},
        },
        {
            name: "ReviewExecutor",
            path: "/performance/reviews/execute/:cycleId/:stepId",
            component: () => import(/* webpackChunkName: "performance" */ "@/router/views/performance/reviews/ReviewExecutor.vue"),
            meta: {},
        },
        {
            name: "FormListing",
            path: "/performance/forms",
            component: () => import(/* webpackChunkName: "performance" */ "@/router/views/performance/forms/Forms.vue"),
            meta: {},
        },
        {
            name: "StepListing",
            path: "/performance/steps",
            component: () => import(/* webpackChunkName: "performance" */ "@/router/views/performance/steps/Steps.vue"),
            meta: {},
        },
        {
            name: "WorkflowListing",
            path: "/performance/workflows",
            component: () => import(/* webpackChunkName: "performance" */ "@/router/views/performance/workflows/Workflows.vue"),
            meta: {},
        },
        {
            name: "CycleListing",
            path: "/performance/cycles",
            component: () => import(/* webpackChunkName: "performance" */ "@/router/views/performance/cycles/Cycles.vue"),
            meta: {},
        },
        {
            name: "CreateCycle",
            path: "/performance/cycles/create",
            component: () => import(/* webpackChunkName: "performance" */ "@/router/views/performance/cycles/CreateCycle.vue"),
            meta: {},
        },
        {
            name: "CycleOverview",
            path: "/performance/cycles/:cycleId",
            component: () => import(/* webpackChunkName: "performance" */ "@/router/views/performance/cycles/CycleOverview.vue"),
            meta: {},
        },
        {
            name: "ClientReview",
            path: "/performance/clientReview/:tenantId/:clientAssignmentId",
            component: () => import("@/router/views/performance/clientReview/ClientReview.vue"),
            meta: {
                publicPage: true,
                tenantAgnostic: true,
            },
        },
        {
            name: "Historics",
            path: "/performance/archives",
            component: () => import("@/router/views/performance/historics/Historic.vue"),
            meta: {},
        },
        {
            name: "GoogleCalendarIntegrationComponent",
            path: "/google/auth",
            component: () => import(/* webpackChunkName: "GoogleCalendarIntegrationComponent" */ "@/router/views/account/GoogleCalendarIntegrationComponent.vue"),
            meta: {},
        },
        {
            name: "PerformanceSettings",
            path: "/performance/settings",
            component: () => import(/* webpackChunkName: "Settings" */ "@/router/views/performance/settings/PerformanceSettings.vue"),
            meta: {},
        },
        // Client
        {
            name: "Clients",
            path: "/clients",
            component: () => import(/* webpackChunkName: "Vendors" */ "@/router/views/client/ClientList.vue"),
            meta: {},
        },
        {
            name: "AddClient",
            path: "/clients/add",
            component: () => import(/* webpackChunkName: "Vendors" */ "@/router/views/client/AddClient.vue"),
            meta: {},
        },
        {
            name: "ClientDetails",
            path: "/clients/:clientId",
            component: () => import(/* webpackChunkName: "Client" */ "@/router/views/client/ClientDetails.vue"),
            meta: {},
        },
        {
            name: "Updates",
            path: "/updates",
            component: () => import(/* webpackChunkName: "Updates" */ "@/router/views/clientUpdates/Updates.vue"),
            meta: {},
        },
        {
            name: "ActionItems",
            path: "/actionItems",
            component: () => import(/* webpackChunkName: "Updates" */ "@/router/views/clientUpdates/actionItems/ActionItems.vue"),
            meta: {},
        },
        {
            name: "WeeklyStandup",
            path: "/weeklyStandup",
            component: () => import(/* webpackChunkName: "Updates" */ "@/router/views/clientUpdates/WeeklyStandup.vue"),
            meta: {},
        },
        {
            name: "ClientHealth",
            path: "/clientHealth",
            component: () => import(/* webpackChunkName: "Client" */ "@/router/views/client/ClientHealth.vue"),
            meta: {},
        },
        {
            name: "OrganizationSetting",
            path: "/organizationSettings",
            component: () => import(/* webpackChunkName: "Client" */ "@/router/views/organizationSetting/OrganizationSetting.vue"),
            meta: {},
        },
        {
            name: "Holidays",
            path: "/holiday",
            component: () => import(/* webpackChunkName: "Holidays" */ "@/router/views/holiday/Holidays.vue"),
            meta: {},
        },
    ],
    // Use the HTML5 history API (i.e. normal-looking routes)
    // instead of routes with hashes (e.g. example.com/#/about).
    // This may require some server configuration in production:
    // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
    mode: "history",
    // Simulate native-like scroll behavior when navigating to a new
    // route and using back/forward buttons.
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        }
        else {
            return { x: 0, y: 0 };
        }
    },
});
